import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import CurvedArrow from 'assets/images/curved-arrow.svg?react';
import noCommentsImage from 'assets/images/noCommentsImage.jpg';

const ArrowIconContainer = styled.div`
  svg {
    fill: ${(props) => props.theme.palette.borders.lightGrey};
    width: 100%;
    height: auto;
  }
  height: 90px;
  width: 70px;
  transform: scaleX(-1) scaleY(-1) rotate(-37deg);
`;

export default function NoCommentsView({
  isCheckIn = false,
  isMeetingNotes = false,
  isDisabled = false,
  firstText = '',
  secondText = '',
}) {
  const text1 =
    firstText ||
    (isCheckIn
      ? 'Enter talking points to keep track'
      : isMeetingNotes
        ? 'Enter meeting notes'
        : 'There are no comments yet');
  const text2 =
    secondText || (isCheckIn ? "of team member's progress" : isMeetingNotes ? 'for the 1:1' : 'Any comments to add?');
  return (
    <Container>
      <StyledImage src={noCommentsImage} />
      <StyledTypography align="center" as="div" variant="subtitle">
        {text1}
      </StyledTypography>
      <StyledTypography align="center" as="div" variant="subtitle" color="textSecondary">
        {text2}
      </StyledTypography>
      {isCheckIn && !isDisabled && (
        <ArrowIconContainer>
          <CurvedArrow />
        </ArrowIconContainer>
      )}
    </Container>
  );
}

const Container = styled.div`
  min-height: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledImage = styled.img`
  max-width: 40%;
`;
